import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { ChevronRight } from '@mui/icons-material';

type Anchor = 'top' | 'left' | 'bottom' | 'right';

export interface DrawerOption {
    label: string,
    icon: any,
    onClick: () => void
}

interface Props {
    anchor: Anchor,
    options: DrawerOption[],
    open: boolean,
    onClose: () => void
}

export default function OptionsDrawer({ anchor, options, open, onClose }: Props) {
    const list = (anchor: Anchor) => (
        <Box
            sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
            role="presentation"
            onClick={onClose}
            onKeyDown={onClose}
            minHeight={50}
        >
            <List>
                {options?.map((option) => (
                    <ListItem onClick={option.onClick} key={option.label} disablePadding>
                        <ListItemButton>
                            <ListItemIcon>
                                {option?.icon}
                            </ListItemIcon>
                            <ListItemText primary={option.label} />
                            <ListItemIcon>
                                <ChevronRight />
                            </ListItemIcon>
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Box>
    );

    return (
        <div>
            <React.Fragment key={anchor}>
                <Drawer
                    anchor={anchor}
                    open={open}
                    onClose={onClose}
                >
                    {list(anchor)}
                </Drawer>
            </React.Fragment>
        </div>
    );
}